<script lang="ts">
	import { MembershipPlanId } from '../pricing/membershipPlanId'
	import { getPricingContext } from '../pricing/pricingContext'
	import { isUsd } from '../pricing/pricingCurrency'
	import { type PricingTableRow, generateTable } from './generateTable'
	import { plans } from './plans'
	import { MembershipsV1BillingCycle } from '@sdk/Api'

	interface Props {
		monthlyRevenue: number
		membershipPlanId: MembershipPlanId
		billingCycle: MembershipsV1BillingCycle
	}

	let { monthlyRevenue, membershipPlanId, billingCycle }: Props = $props()

	const { pricingTable } = getPricingContext()

	let tableRows = $derived(generateTable(pricingTable, membershipPlanId, billingCycle, $isUsd))

	// Function to check if the row should be highlighted
	function isHighlighted(row: PricingTableRow, currentRevenue: number) {
		if (row.upperBound === Infinity) {
			return currentRevenue >= row.lowerBound
		}
		return currentRevenue >= row.lowerBound && currentRevenue <= row.upperBound
	}

	let isOverchargesAvailable = $derived(
		[MembershipPlanId.STARTER, MembershipPlanId.BUSINESS].includes(membershipPlanId),
	)
</script>

<table class="w-full caption-bottom rounded-b-lg max-md:text-xs">
	<thead>
		<tr class="font-display text-muted">
			<th class="w-2 md:w-7.5"></th>
			<th class="py-2 font-normal md:w-1/2">Revenue Generated by Affiliates</th>
			<th class="py-2 font-normal md:w-1/4">
				{billingCycle === MembershipsV1BillingCycle.BILLING_CYCLE_MONTHLY
					? 'Monthly'
					: 'Monthly price, billed annually'}
			</th>
			<th class="py-2 font-normal">
				{#if isOverchargesAvailable}Overcharges (per 1k Revenue){/if}
			</th>
			<th class="w-2 md:w-7.5"></th>
		</tr>
	</thead>
	<tbody>
		{#each tableRows as row}
			{@const activeStyles = isHighlighted(row, monthlyRevenue)
				? plans.find((plan) => plan.id === membershipPlanId).activeStyles
				: ''}
			<tr class="group">
				<td class={activeStyles}></td>
				<td
					class="border-t-line border-t py-2.5 whitespace-nowrap group-first:border-t-0 {activeStyles ||
						'group-even:bg-box'}"
				>
					{row.revenueRange}
				</td>
				<td
					class="border-t-line border-t py-2.5 group-first:border-t-0 {activeStyles ||
						'group-even:bg-box'}"
				>
					{#if row.link}
						<a class="underline hover:no-underline" href={row.link}>{row.monthlyPayment}</a>
					{:else}
						{row.monthlyPayment}
					{/if}
				</td>
				<td
					class="border-t-line border-t py-2.5 group-first:border-t-0 {activeStyles ||
						'group-even:bg-box'}"
				>
					{#if isOverchargesAvailable}
						{#if row.link}
							<a class="underline hover:no-underline" href={row.link}>{row.overcharges}</a>
						{:else}
							{row.overcharges}
						{/if}
					{/if}
				</td>

				<td class={activeStyles}></td>
			</tr>
		{/each}
	</tbody>
</table>
